<template>
  <div class="vi-phone-number">
    <vi-country-code-picker v-model="countryCode" :countries="countries" @input="onInput"/>
    <input ref="input" v-model="phoneNumber" type="text" @input="onInput" />
    <div class="bg-input"></div>
  </div>
</template>

<script>
  import ViCountryCodePicker from "./ViCountryCodePicker";
  import {countries} from 'countries-list';

  export default {
    name: 'ViPhoneNumber',
    components: {ViCountryCodePicker},

    props: {
      autofocus: {
        type: Boolean,
        default: false
      },
      value: {
        type: String
      }
    },

    data: () => ({
      countryCode: 'US',
      countries,
      phoneNumber: null
    }),

    methods: {
      onInput() {
        this.$emit('input', '+' + this.countries[this.countryCode].phone + this.phoneNumber)
      },
    },

    mounted() {
      if(this.autofocus) {
        try {
          this.$refs.input.focus()
        } catch (e) {

        }
      }
      if(this.value) {
        let tmpVal = this.value.replace('+', '');
        let prefix = '';
        let newCountry = null
        Object.keys(this.countries)
          .forEach(country => {
            let c = this.countries[country];
            if(tmpVal.startsWith(c.phone) && c.phone.length >= prefix.length) {
              prefix = c.phone;
              newCountry = country
            }
          })

        if(newCountry) {
          this.countryCode = newCountry;
          this.phoneNumber = tmpVal.replace(prefix, '')
        }
      }
      console.log(this.countries)
    }

  }
</script>

<style lang="scss">
.vi-phone-number {
  margin-top: 20px;
  position: relative;
  display: flex;
  z-index: 1;
  align-items: center;
  box-sizing: border-box;

  input:focus + .bg-input {
    box-shadow: 0 0 1px 2px #08A5B4;
  }

  input {
    background: none;
    border: none;
    padding: 6px 10px 6px 0;
    flex: 1;
    font-size: 16px;
    outline: none;
  }

  .bg-input {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    border-radius: 10px;
    border: none;
    padding: 6px 10px;
    /*text-align: center;*/
    font-size: 16px;
    outline: none;
    background: #ffffff;
  }
}
</style>
